import { Pipe, PipeTransform } from '@angular/core';
import { AppointmentRequestType } from '@warema/shared/models';

@Pipe({
    name: 'appointmentRequestTypePipe',
})
export class AppointmentRequestTypePipe implements PipeTransform {
    public transform(requestType: AppointmentRequestType): string {
        switch (requestType) {
            case AppointmentRequestType.Private:
                return 'PRIVATE';

            case AppointmentRequestType.Commercial:
                return 'COMMERCIAL';

            default:
                return 'UNKNOWN';
        }
    }
}
